
const reportCommonSectionFormat = [
  {
    label: 'Cancer Type',
    fields: [
      {
        label: 'Cancer Type',
        value: 'not_selected', // 선택 값 저장
        form: 'select',
        list: { options: [
          { label: 'Not Selected', value: 'not_selected' },
          { label: 'Breast Cancer', value: 'breast' },
          { label: 'Thyroid Cancer', value: 'thyroid' },
          { label: 'Colorectal Cancer', value: 'colon' },
          { label: 'Lung Cancer', value: 'lung' },
          { label: 'Gastric Cancer', value: 'stomach' },
          { label: 'Liver Cancer', value: 'liver' },
          { label: 'Pancreatic Cancer', value: 'pancreas' },
          { label: 'Cervical Cancer', value: 'cervix' },
          { label: 'Ovarian Cancer', value: 'ovary' },
          { label: 'Prostate Cancer', value: 'prostate' },
          { label: 'Melanoma', value: 'melanoma' }
        ]}
      }
    ]
  },
  {
    label: 'Specimen Information',
    fields: [
      { label: 'Accession Number', value: '', form: 'input' },
      { label: 'Specimen Name', value: '', form: 'input' },
      { label: 'Specimen Status', value: 'Fresh', form: 'radio', list: { options: ['Fresh', 'Fixed', 'Frozen'] } },
      { label: 'Specimen Orientation', value: '', form: 'checkbox' },
      { label: 'Specimen Location', value: '', form: 'input' },
      { label: 'Specimen Size', value: '', form: 'input' },
      { label: 'Frozen Section Performed', value: false, form: 'checkbox' }
    ]
  },
  {
    label: 'Tumor Information',
    fields: [
      { label: 'Anatomic Site', value: '', form: 'input' },
      { label: 'Maximum Tumor Dimension', value: '', form: 'input' },
      { label: 'Number of Lesions', value: '1', form: 'input' },
      { label: 'Histologic Type', value: '', form: 'input' },
      { label: 'Histologic Grade', value: 'Not Specified', form: 'radio', list: { options: ['Not Specified', 'Low','Intermediate','High'] } },
      { label: 'Invasion', value: [], form: 'checkbox', list: { options: ['Vascular','Lymphatic','Perineural'] } },
      { label: 'Distance to Closest Margin', value: '', form: 'input' },
      { label: 'Margin Status', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
    ]
  },
  {
    label: 'Lymph Node Evaluation',
    fields: [
      { label: 'Number of Lymph Nodes Examined', value: '', form: 'input' },
      { label: 'Number of Positive Nodes', value: '', form: 'input' },
      { label: 'Extranodal Extension', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
    ]
  },
  {
    label: 'Pathologic Staging TNM Classification',
    fields: [
      { label: 'pT: Pathologic Tumor', value: 'None', form: 'radio', list: { options: ['None', 'pT1', 'pT2', 'pT3', 'pT4'] } },
      { label: 'pN: Pathologic Node', value: 'None', form: 'radio', list: { options: ['None', 'pN0', 'pN1', 'pN2', 'pN3'] } },
      { label: 'pM: Pathologic Metastasis', value: 'None', form: 'radio', list: { options: ['None', 'pM0', 'pM1'] } },
      { label: 'Stage / Substage', value: '', form: 'input', note: 'Automatically calculated from TNM selection, editable if needed' }
    ]
  },
  {
    label: "Pathologist's Comment",
    fields: [
      { label: 'Comment', value: '', form: 'input' }
    ]
  },
];

const reportSpecialSectionFormat = {
  // 0번: 선택 안함
  'not_selected': [],
  
  // 1번: 유방암
  'breast': [
    {
      label: 'In Situ Component (DCIS)',
      fields: [
        { label: 'Presence of DCIS', value: 'Absent', form: 'radio', list: { options: ['Present', 'Absent'] } },
        { label: 'Extent of DCIS', value: 'None', form: 'radio', list: { options: ['None', 'Focal', 'Extensive'] } },
        { label: 'Nuclear Grade', value: 'None', form: 'radio', list: { options: ['None', 'Grade 1', 'Grade 2', 'Grade 3'] } },
        { label: 'Necrosis', value: 'None', form: 'radio', list: { options: ['None', 'Present (comedo-type)', 'Absent'] } },
      ]
    },
    {
      label: 'Histologic Type - Breast-Specific Variants',
      fields: [
        { label: 'Invasive Component', value: '', form: 'input' },
        { label: 'In Situ Component', value: '', form: 'input' },
        { label: 'Special Variants', value: '', form: 'input' },
      ]
    },
    {
      label: 'Nottingham Histologic Grade',
      fields: [
        { label: 'Tubule Formation', value: 'None', form: 'radio', list: { options: ['None', 'Score 1','Score 2','Score 3'] } },
        { label: 'Nuclear Pleomorphism', value: 'None', form: 'radio', list: { options: ['None', 'Score 1','Score 2','Score 3'] } },
        { label: 'Mitotic Rate', value: 'None', form: 'radio', list: { options: ['None', 'Score 1','Score 2','Score 3'] } },
        { label: 'Overall Grade', value: 'None', form: 'radio', list: { options: ['None', 'Grade 1','Grade 2','Grade 3'] } },
      ]
    },
    {
      label: 'Hormone Receptor Status (IHC)',
      fields: [
        { label: 'Estrogen Receptor (ER)', value: '', form: 'input' },
        { label: 'Progesterone Receptor (PR)', value: '', form: 'input' },
      ]
    },
    {
      label: 'HER2 Status',
      fields: [
        { label: 'HER2 IHC Score', value: '', form: 'input' },
        { label: 'HER2 FISH Result', value: '', form: 'input' },
        { label: 'HER2/CEP17 Ratio', value: '', form: 'input' },
      ]
    },
    {
      label: 'Ki-67 Proliferation Index',
      fields: [
        { label: 'Ki-67', value: '', form: 'input' },
      ]
    },
    {
      label: 'Breast Cancer Biomarker-Based Subtype',
      fields: [
        { label: 'Subtype', value: '', form: 'input' },
      ]
    },
    {
      label: 'Sentinel Lymph Node Biopsy Findings',
      fields: [
        { label: 'Type of Node Sampled', value: '', form: 'input' },
        { label: 'Macrometastasis', value: '', form: 'input' },
        { label: 'Micrometastasis', value: '', form: 'input' },
        { label: 'Isolated Tumor Cells (ITC)', value: '', form: 'input' },
      ]
    },
    {
      label: 'Lymphovascular Invasion - Breast Specific Detail',
      fields: [
        { label: 'Lymphovascular Invasion (LVI)', value: 'Absent', form: 'radio', list: { options: ['Present', 'Absent'] } },
        { label: 'Extent', value: 'None', form: 'radio', list: { options: ['None', 'Focal','Extensive'] } },
      ]
    },
    {
      label: 'DCIS / LCIS Special Findings',
      fields: [
        { label: 'LCIS (Lobular Carcinoma In Situ)', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Calcifications', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Architectural Pattern (DCIS)', value: '', form: 'input'},
      ]
    },
    {
      label: 'Multifocality / Multicentricity',
      fields: [
        { label: 'Multifocal Tumors', value: '', form: 'input'},
        { label: 'Largest Lesion', value: '', form: 'input'},
      ]
    },
    {
      label: 'Skin / Nipple / Chest Wall Involvement',
      fields: [
        { label: 'Nipple Involvement', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Skin Involvement', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Chest Wall Invasion', value: '', form: 'input'},
      ]
    }
  ],
  // 2번: 갑상선암
  'thyroid': [
    {
      label: 'Histologic Type',
      fields: [
        { label: 'Histologic Type', value: '', form: 'input' },
        { label: 'Variant', value: '', form: 'input' },
        { label: 'Follicular Variant', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
      ]
    },
    {
      label: 'Tumor Size',
      fields: [
        { label: 'Maximum Tumor Dimension', value: '', form: 'input' }
      ]
    },
    {
      label: 'Capsular and Vascular Invasion',
      fields: [
        { label: 'Capsular Invasion', value: 'Absent', form: 'radio', list: { options: ['Present', 'Absent'] } },
        { label: 'Vascular Invasion', value: 'Absent', form: 'radio', list: { options: ['Present', 'Absent'] } },
        { label: 'Number of Vessels Involved', value: '0', form: 'input' },
      ]
    },
    {
      label: 'Extrathyroidal Extension',
      fields: [
        { label: 'Extrathyroidal Extension', value: 'None', form: 'radio', list: { options: ['None','Focal','Extensive'] } },
        { label: 'Involved Structures', value: '', form: 'input' },
      ]
    },
    {
      label: 'Multifocality',
      fields: [
        { label: 'Multifocal Tumors', value: '', form: 'input' },
        { label: 'Largest Lesion', value: '', form: 'input' },
      ]
    },
    {
      label: 'Calcifications',
      fields: [
        { label: 'Calcifications', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Pattern', value: '', form: 'input' },
      ]
    },
    {
      label: 'Ancillary Studies',
      fields: [
        { label: 'Thyroglobulin (IHC)', value: 'Negative', form: 'radio', list: { options: ['Negative','Negative'] } },
        { label: 'TTF-1 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Calcitonin (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'BRAF V600E mutation', value: 'Not detected', form: 'radio', list: { options: ['Detected','Not detected'] } },
      ]
    }
  ],

  // 3번. 대장암
  'colon': [
    {
      label: 'Histologic Type',
      fields: [
        { label: 'Histologic Type', value: '', form: 'input' },
        { label: 'Subtypes', value: '', form: 'input' },
      ]
    },
    {
      label: 'Depth of Invasion',
      fields: [
        { label: 'Invasion of Adjacent Structures', value: '', form: 'input' },
      ]
    },
    {
      label: 'Lymphovascular Invasion',
      fields: [
        { label: 'Lymphatic Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Venous Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
      ]
    },
    {
      label: 'Perineural Invasion',
      fields: [
        { label: 'Perineural Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
      ]
    },
    {
      label: 'Resection Margins',
      fields: [
        { label: 'Proximal Margin', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Distal Margin', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Radial / Circumferential Margin', value: '', form: 'input' },
      ]
    },
    {
      label: 'Tumor Budding',
      fields: [
        { label: 'Tumor Budding', value: '0', form: 'input' },
      ]
    },
    {
      label: 'Mismatch Repair (MMR)',
      fields: [
        { label: 'MMR Status', value: 'None', form: 'radio', list: { options: ['None', 'Microsatellite stable (MSS)', 'Microsatellite instability-high (MSI-H)'] } },
        { label: 'IHC Markers', value: '', form: 'input' },
      ]
    },
    {
      label: 'Ancillary Studies',
      fields: [
        { label: 'KRAS / NRAS / BRAF Mutation', value: '', form: 'input' },
        { label: 'Other Molecular Tests', value: 'Not performed', form: 'radio', list: { options: ['Performed','Not performed'] } },
      ]
    }
  ],
  'lung': [
    {
      label: 'Histologic Type',
      fields: [
        { label: 'Histologic Type', value: '', form: 'input' },
        { label: 'Subtype', value: '', form: 'input' },
        { label: 'Other Variants', value: 'Absent', form: 'radio', list: { options: ['Present', 'Absent'] } },
      ]
    },
    {
      label: 'Invasion',
      fields: [
        { label: 'Visceral Pleural Invasion', value: 'Absent', form: 'radio', list: { options: ['Present', 'Absent'] } },
        { label: 'Chest Wall', value: 'Absent', form: 'radio', list: { options: ['Present', 'Absent'] } },
        { label: 'Vascular Invasion', value: 'Absent', form: 'radio', list: { options: ['Present', 'Absent'] } },
        { label: 'Lymphatic Invasion', value: 'Absent', form: 'radio', list: { options: ['Present', 'Absent'] } },
        { label: 'Perineural Invasion', value: 'Absent', form: 'radio', list: { options: ['Present', 'Absent'] } },
      ]
    },
    {
      label: 'Molecular Studies',
      fields: [
        { label: 'EGFR Mutation', value: 'L858R detected', form: 'radio', list: { options: ['Detected','Not detected'] } },
        { label: 'KRAS Mutation', value: 'Not detected', form: 'radio', list: { options: ['Detected','Not detected'] } },
        { label: 'ALK Rearrangement', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'PD-L1 Expression', value: '', form: 'input' },
      ]
    },
    {
      label: 'Ancillary Studies',
      fields: [
        { label: 'TTF-1 (IHC)', value: 'Not performed', form: 'radio', list: { options: ['Positive','Negative','Not performed'] } },
        { label: 'Napsin A (IHC)', value: 'Not performed', form: 'radio', list: { options: ['Positive','Negative','Not performed'] } },
        { label: 'Special Stains', value: 'Not performed', form: 'radio', list: { options: ['Performed','Not performed'] } },
      ]
    },
    {
      label: 'Tumor Grade',
      fields: [
        { label: 'Grade', value: 'None', form: 'radio', list: { options: ['None', 'Well', 'Moderate', 'Poor'] } },
      ]
    }
  ],
  'stomach': [
    {
      label: 'Histologic Type',
      fields: [
        { label: 'Histologic Type', value: '', form: 'input' },
        { label: 'Lauren Classification', value: 'Intestinal type', form: 'radio', list: { options: ['Intestinal type','Diffuse type','Mixed','Indeterminate'] } },
        { label: 'Differentiation', value: 'Moderately differentiated', form: 'radio', list: { options: ['Well differentiated','Moderately differentiated','Poorly differentiated'] } },
        { label: 'Other Variants', value: '', form: 'input' },
      ]
    },
    {
      label: 'Depth of Invasion',
      fields: [
        { label: 'Layer Involved', value: 'Muscularis propria', form: 'radio', list: { options: ['Mucosa','Submucosa','Muscularis propria','Subserosa','Serosa'] } },
        { label: 'Serosal Involvement', value: '', form: 'radio', list: { options: ['Present','Absent'] } },
      ]
    },
    {
      label: 'Lymphovascular Invasion',
      fields: [
        { label: 'Lymphatic Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Venous Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
      ]
    },
    {
      label: 'Perineural Invasion',
      fields: [
        { label: 'Perineural Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
      ]
    },
    {
      label: 'Resection Margins',
      fields: [
        { label: 'Proximal Margin', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Distal Margin', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Radial / Circumferential Margin', value: 'Not involved', form: 'radio', list: { options: ['Involved','Not involved'] } },
      ]
    },
    {
      label: 'Tumor Budding',
      fields: [
        { label: 'Tumor Budding', value: 'Low (3 buds / 0.785 mm²)', form: 'radio', list: { options: ['Low','Intermediate','High'] } },
      ]
    },
    {
      label: 'Microsatellite Status',
      fields: [
        { label: 'MSI', value: 'Microsatellite stable (MSS)', form: 'radio', list: { options: ['Microsatellite stable (MSS)','Microsatellite instability-high (MSI-H)'] } },
      ]
    },
    {
      label: 'Ancillary Studies',
      fields: [
        { label: 'HER2 (IHC)', value: '', form: 'input' },
        { label: 'PD-L1', value: '', form: 'input' },
        { label: 'Molecular Studies', value: '', form: 'input' },
      ]
    }
  ], 
  'liver': [
    {
      label: 'Histologic Type',
      fields: [
        { label: 'Histologic Type', value: '', form: 'input' },
        { label: 'Subtype', value: '', form: 'input' },
        { label: 'Other Variants', value: 'Fibrolamellar variant: Not identified', form: 'radio', list: { options: ['Identified','Not identified'] } },
      ]
    },
    {
      label: 'Tumor Grade',
      fields: [
        { label: 'Edmondson-Steiner Grade', value: 'Grade II', form: 'radio', list: { options: ['Grade I', 'Grade II', 'Grade III', 'Grade IV'] } },
      ]
    },
    {
      label: 'Vascular Invasion',
      fields: [
        { label: 'Macrovascular Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Microvascular Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
      ]
    },
    {
      label: 'Capsule',
      fields: [
        { label: 'Fibrous Capsule', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Capsular Invasion', value: '', form: 'radio', list: { options: ['Present','Absent'] } },
      ]
    },
    {
      label: 'Background Liver',
      fields: [
        { label: 'Cirrhosis', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Steatosis', value: 'None', form: 'radio', list: { options: ['None','Mild','Moderate','Severe'] } },
        { label: 'Chronic Hepatitis', value: '', form: 'input' },
      ]
    },
    {
      label: 'Ancillary Studies',
      fields: [
        { label: 'HepPar-1 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Glypican-3 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'CK7 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Molecular Studies', value: 'Not performed', form: 'radio', list: { options: ['Present','Absent'] } },
      ]
    }
  ],
  'pancreas': [
    {
      label: 'Histologic Type',
      fields: [
        { label: 'Histologic Type', value: '', form: 'input' },
        { label: 'Grade', value: 'Moderate', form: 'radio', list: { options: ['Well','Moderate','Poor'] } },
        { label: 'Special Variants', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Invasion',
      fields: [
        { label: 'Peripancreatic Fat Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Duodenal', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Common Bile Duct', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Vascular Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Perineural Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Resection Margins',
      fields: [
        { label: 'Pancreatic Margin', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Bile Duct Margin', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Duodenal Margin', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Retroperitoneal Margin', value: 'Not involved', form: 'radio', list: { options: ['Involved','Not involved'] } }
      ]
    },
    {
      label: 'Tumor Budding',
      fields: [
        { label: 'Tumor Budding', value: '', form: 'input' }
      ]
    },
    {
      label: 'Molecular / Ancillary Studies',
      fields: [
        { label: 'KRAS Mutation', value: '', form: 'input' },
        { label: 'TP53', value: '', form: 'input' },
        { label: 'CK7 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'CK20 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'CA19-9 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } }
      ]
    }
  ],
  'cervix': [
    {
      label: 'Histologic Type',
      fields: [
        { label: 'Histologic Type', value: '', form: 'input' },
        { label: 'Grade', value: 'Moderately differentiated', form: 'radio', list: { options: ['Well','Moderate','Poor'] } },
        { label: 'Adenocarcinoma Component', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Depth of Invasion',
      fields: [
        { label: 'Stromal Invasion', value: '', form: 'input' },
        { label: 'Proportion of Cervical Wall', value: '', form: 'input' }
      ]
    },
    {
      label: 'Lymphovascular Invasion',
      fields: [
        { label: 'Lymphatic Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Vascular Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Parametrial Involvement',
      fields: [
        { label: 'Parametrial Involvement', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Margins',
      fields: [
        { label: 'Endocervical Margin', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Vaginal Margin', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Parametrial Margin', value: 'Not involved', form: 'radio', list: { options: ['Involved','Not involved'] } }
      ]
    },
    {
      label: 'Ancillary Studies',
      fields: [
        { label: 'HPV Testing', value: 'High-risk HPV positive', form: 'radio', list: { options: ['High-risk HPV positive','Negative'] } },
        { label: 'p16 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Ki-67 (IHC)', value: '', form: 'input' }
      ]
    }
  ],
  'ovary': [
    {
      label: 'Histologic Type',
      fields: [
        { label: 'Histologic Type', value: '', form: 'input' },
        { label: 'Grade', value: 'Grade 3', form: 'radio', list: { options: ['Grade 1','Grade 2','Grade 3'] } },
        { label: 'Other Variants', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Surface Involvement',
      fields: [
        { label: 'Surface Involvement', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Capsular Invasion',
      fields: [
        { label: 'Capsular Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Lymphovascular Invasion',
      fields: [
        { label: 'Lymphatic Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Vascular Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Peritoneal/Extraovarian Spread',
      fields: [
        { label: 'Peritoneal Implant', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Omentum', value: 'Involved', form: 'radio', list: { options: ['Involved','Not involved'] } },
        { label: 'Other Organs', value: 'Involved', form: 'radio', list: { options: ['Involved','Not involved'] } }
      ]
    },
    {
      label: 'Ancillary Studies',
      fields: [
        { label: 'WT1 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'PAX8 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'p53 (IHC)', value: '', form: 'input' },
        { label: 'BRCA1/2 mutation', value: 'Detected', form: 'radio', list: { options: ['Detected','Not detected'] } }
      ]
    }
  ],
  'prostate': [
    {
      label: 'Histologic Type',
      fields: [
        { label: 'Histologic Type', value: '', form: 'input' },
        { label: 'Gleason Score', value: '', form: 'input' },
        { label: 'Grade Group', value: 'Grade Group 1', form: 'radio', list: { options: ['Grade Group 1','Grade Group 2','Grade Group 3','Grade Group 4','Grade Group 5'] } },
        { label: 'Other Variants', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Extraprostatic Extension',
      fields: [
        { label: 'Extraprostatic Extension', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Seminal Vesicle Invasion',
      fields: [
        { label: 'Seminal Vesicle Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Surgical Margins',
      fields: [
        { label: 'Margin Status', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Closest Margin', value: '', form: 'input' }
      ]
    },
    {
      label: 'Perineural Invasion',
      fields: [
        { label: 'Perineural Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Ancillary Studies',
      fields: [
        { label: 'PSA (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'AMACR (P504S, IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'CK5/6 (IHC)', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Molecular Studies', value: 'Performed', form: 'radio', list: { options: ['Performed','Not performed'] } }
      ]
    }
  ],
  'melanoma': [
    {
      label: 'Histologic Type',
      fields: [
        { label: 'Histologic Type', value: '', form: 'input' },
        { label: 'Subtype', value: 'Not otherwise specified', form: 'radio', list: { options: ['Not otherwise specified','Other'] } },
        { label: 'Other Variants', value: '', form: 'input' }
      ]
    },
    {
      label: 'Tumor Location',
      fields: [
        { label: 'Anatomic Site', value: '', form: 'input' },
        { label: 'Laterality', value: 'Right', form: 'radio', list: { options: ['Right','Left','Midline'] } }
      ]
    },
    {
      label: 'Tumor Thickness',
      fields: [
        { label: 'Breslow Thickness', value: '', form: 'input' },
        { label: 'Clark Level', value: 'I', form: 'radio', list: { options: ['I','II','III','IV','V'] } }
      ]
    },
    {
      label: 'Ulceration',
      fields: [
        { label: 'Ulceration', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Mitotic Rate',
      fields: [
        { label: 'Mitotic Figures', value: '', form: 'input' }
      ]
    },
    {
      label: 'Sentinel Lymph Node Biopsy',
      fields: [
        { label: 'Type of Node Sampled', value: '', form: 'input'},
        { label: 'Macrometastasis', value: '', form: 'input'},
        { label: 'Micrometastasis', value: '', form: 'input'},
        { label: 'Isolated Tumor Cells', value: '', form: 'input'}
      ]
    },
    {
      label: 'Lymphovascular Invasion',
      fields: [
        { label: 'Lymphatic Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } },
        { label: 'Vascular Invasion', value: 'Absent', form: 'radio', list: { options: ['Present','Absent'] } }
      ]
    },
    {
      label: 'Tumor-Infiltrating Lymphocytes',
      fields: [
        { label: 'TILs', value: 'Absent', form: 'radio', list: { options: ['Absent','Mild','Moderate','Marked'] } }
      ]
    },
    {
      label: 'Margins',
      fields: [
        { label: 'Margin Status', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Closest Margin', value: '', form: 'input' }
      ]
    },
    {
      label: 'Ancillary Studies',
      fields: [
        { label: 'S100', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'HMB-45', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Melan-A', value: 'Negative', form: 'radio', list: { options: ['Positive','Negative'] } },
        { label: 'Molecular Studies', value: '', form: 'input' }
      ]
    }
  ],
};

export {
  reportCommonSectionFormat,
  reportSpecialSectionFormat,
};